export function findByPath(obj, path, defaultValue, suffix) {
    let result = obj;
    for (const field of path.split('.')) {
        if (!result) {
            return defaultValue;
        }
        result = result[field];
    }
    return `${result}${suffix}`;
}
//# sourceMappingURL=utils.js.map